
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.273 36H12.25c-3.378 0-6.265-1.181-8.66-3.544C1.195 30.094 0 27.206 0 23.794c0-2.925.872-5.532 2.617-7.819s4.028-3.75 6.849-4.387c.928-3.45 2.784-6.244 5.568-8.382C17.818 1.07 20.974 0 24.5 0c4.343 0 8.028 1.528 11.054 4.585 3.026 3.058 4.538 6.779 4.537 11.165 2.561.3 4.687 1.416 6.377 3.348C48.158 21.03 49 23.289 49 25.875c0 2.813-.975 5.203-2.924 7.173-1.95 1.97-4.316 2.953-7.099 2.952h-12.25V19.913l3.564 3.487 3.118-3.15-8.909-9-8.91 9 3.12 3.15 3.563-3.487V36z","fill":"#6C7589"}})])
          )
        }
      }
    